export const getEloquaCss = (themeColorHex) => {
  const buttonClassPath = '.submit-button-style'
  const labelClassPath = '.elq-label'
  const itemInputClassPath = '.elq-item-input'
  const itemSelectClassPath = '.elq-item-select'

  return `body {
    margin: 0;
    font-family: Roboto, sans-serif !important;
    overflow: hidden;
  }
  .elq-form .container-fluid { padding: 0; }
  .elq-form .row { margin: 0; }
  .form-element-layout { padding: 0; }
  .elq-form .col-lg-1,.elq-form .col-lg-2,.elq-form .col-lg-3,.elq-form .col-lg-4,.elq-form .col-lg-5,.elq-form .col-lg-6,.elq-form .col-lg-7,.elq-form .col-lg-8,.elq-form .col-lg-9,.elq-form .col-lg-10,.elq-form .col-lg-11,.elq-form .col-lg-12,.elq-form .col-md-1,.elq-form .col-md-2,.elq-form .col-md-3,.elq-form .col-md-4,.elq-form .col-md-5,.elq-form .col-md-6,.elq-form .col-md-7,.elq-form .col-md-8,.elq-form .col-md-9,.elq-form .col-md-10,.elq-form .col-md-11,.elq-form .col-md-12,.elq-form .col-sm-1,.elq-form .col-sm-2,.elq-form .col-sm-3,.elq-form .col-sm-4,.elq-form .col-sm-5,.elq-form .col-sm-6,.elq-form .col-sm-7,.elq-form .col-sm-8,.elq-form .col-sm-9,.elq-form .col-sm-10,.elq-form .col-sm-11,.elq-form .col-sm-12,.elq-form .col-xs-1,.elq-form .col-xs-2,.elq-form .col-xs-3,.elq-form .col-xs-4,.elq-form .col-xs-5,.elq-form .col-xs-6,.elq-form .col-xs-7,.elq-form .col-xs-8,.elq-form .col-xs-9,.elq-form .col-xs-10,.elq-form .col-xs-11,.elq-form .col-xs-12{
    position:relative;
    min-height:1px;
    padding-right:0px;
    padding-left:0px
  }
  .layout-col { margin: 0; }
  ${buttonClassPath} {
      background-color: ${themeColorHex};
      border-color: ${themeColorHex};
      width: 100%;
      border: 0.3rem;
      color: white;
      font-weight: 500;
    }
    ${labelClassPath} {
      font-size: 0.8rem;
      color: #627d98;
      margin-bottom: 0.1rem !important;
      font-weight: 500 !important;
    }
    ${itemInputClassPath} {
      border: 0.1rem solid #829AB1;
      border-radius: 0.2rem;
      padding: 0.3rem 0.3rem;
      margin-bottom: 0.3rem !important;
      font-size: 14px !important;
      height: 2rem !important;
    }
    ${itemSelectClassPath} {
      margin-bottom: 0.3rem !important;
      border: none;
      background-color: transparent;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
      border: 0.1rem solid #829AB1;
      border-radius: 0.3rem;
      padding: 0.3rem 0.3rem;
      margin-bottom: 1.5rem;
    }`
}
